import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const InlineCommentsHighlighterLoader: LoadableType<{
	pageId: string;
}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-LazyInlineCommentsHighlighter" */ './InlineCommentsHighlighter.tsx'
			)
		).InlineCommentsHighlighter,
});
